import { useContext, useEffect, useState } from 'react';
import { createPath, parsePath } from 'history';
import { UNSAFE_LocationContext } from 'react-router-dom';
import { ensureBaseURL, isAbsoluteURL, resolveURL } from '@philips-internal/oswald-common-utils';
import { ConfigurationService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
function useRouterContext(to) {
    const locationContext = useContext(UNSAFE_LocationContext);
    const [href, setHref] = useState('');
    const [target, setTarget] = useState(to);
    useEffect(() => {
        const location = locationContext?.location;
        // @ts-ignore: `react-router` restricts the History type down to some basic functionalities and
        // renames it to navigator, but it still is the full history object.
        const href = createHref(target, location);
        setHref(href);
    }, [target]);
    return [href, setTarget];
}
function createHref(to, currentLocation) {
    if (isAbsoluteURL(to)) {
        return to;
    }
    const base = ConfigurationService.getBaseURL();
    const href = createPath(createLocation(to, currentLocation));
    return ensureBaseURL(href, base);
}
// The following function has been copied and adapted for our needs from `history@v4.10.1` on 07/22/2022.
// The copy was necessary because the latest `history` package version does not have this function anymore.
// Reference: https://github.com/remix-run/history/blob/3f69f9e07b0a739419704cffc3b3563133281548/modules/LocationUtils.js
function createLocation(to, currentLocation) {
    const location = parsePath(to);
    try {
        location.pathname = decodeURI(location.pathname ?? '');
    }
    catch (error) {
        if (error instanceof URIError) {
            throw new URIError(`Pathname "${location.pathname}" could not be decoded. This is likely caused by an invalid percent-encoding.`);
        }
        else {
            throw error;
        }
    }
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) {
            location.pathname = currentLocation.pathname;
        }
        else if (location.pathname.charAt(0) !== '/') {
            location.pathname = resolveURL(currentLocation.pathname, location.pathname);
        }
    }
    else {
        // When there is no prior location and pathname is empty, set it to /
        if (!location.pathname) {
            location.pathname = '/';
        }
    }
    return location;
}
export { useRouterContext, };
//# sourceMappingURL=use-router-context.js.map